/* eslint-disable prettier/prettier */
import * as Yup from 'yup';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import PackageForm from './PackageForm';
import { formDataConverterNew } from '../../../../utils/necessaryFunctions';

const PackageFormContainer = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        price: editData?.price || '',
        min_age: editData?.min_age || '',
        description: editData?.description || '',
        highlights_description: editData?.highlights_description || '',
        destination_id: editData?.destination_id || '',
        travelCategoryId: editData?.travelCategoryId || '',
        tourTypeId: editData?.tourTypeId || '',
        duration: parseInt(editData?.duration, 10) || '',
        tour_month:
            editData?.package_months?.map((item) => ({
                label: item?.month?.name,
                value: item?.month_id,
            })) || [],
        // tour_month: editData?.tour_month || '',
        // package_months: editData?.tour_month?.map((m) =>
        // ({
        //     month_id: m?.month_id,
        //     month: m?.month.name,
        // }
        // )) || [],
        package_discount: editData?.package_discount || '',
        status: editData?.status === 0 ? 0 : 1 || 1,
        // facility: editData?.facility?.map((item) => ({
        //     value: item.value,
        // })) || [{ value: '' }],
        included: editData?.includes?.map((item) => ({
            value: item.value,
        })) || [{ value: '' }],
        excluded: editData?.excludes?.map((item) => ({
            value: item.value,
        })) || [{ value: '' }],
        highlights_bulletpoints: editData?.points?.map((item) => ({
            value: item.value,
        })) || [{ value: '' }],
        itinerary: editData?.itineraries?.map((item) => ({
            // day: item.day,
            value: item.value,
        })) || [{ value: '' }],
        // features: editData?.package_features?.map((item) => ({
        //     name: item.name,
        //     value: item.value,
        // })) || [{ name: '', value: '' }],
    };
    //! Active validationSchema testing
    // const validationSchema = Yup.object().shape({
    //     name: Yup.string().required('Name is required'),

    //     price: Yup.number()
    //         .typeError('Price must be a number')
    //         .required('Price is required')
    //         .positive('Price must be a positive number'),
    //     tourType: Yup.string().required('Tour Type ID is required'),

    //     duration: Yup.number()
    //         .typeError('Duration must be a number')
    //         .required('Duration is required'),

    //     package_discount: Yup.number()
    //         .typeError('Discount must be a number')
    //         .min(0, 'Discount cannot be negative')
    //         .max(100, 'Discount cannot be more than 100')
    //         .nullable(),

    //     status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),

    //     included: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Included item value is required'),
    //         })
    //     ),

    //     excluded: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Excluded item value is required'),
    //         })
    //     ),

    //     highlights_bulletpoints: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Highlight bullet point is required'),
    //         })
    //     ),

    //     itinerary: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Itinerary item is required'),
    //         })
    //     ),

    //     features: Yup.array().of(
    //         Yup.object().shape({
    //             name: Yup.string().required('Feature name is required'),
    //             value: Yup.string().required('Feature value is required'),
    //         })
    //     ),
    // });

    const validationSchema = Yup.object().shape({
        //     // name: Yup.string().required('Name is required'),
        //     // price: Yup.number()
        //     //     .typeError('Price must be a number')
        //     //     .required('Price is required')
        //     //     .positive('Price must be a positive number'),
        //     // tourType: Yup.string().required('Tour Type ID is required'),
        //     // duration: Yup.string().required('Duration ID is required'),
        //     // package_discount: Yup.number()
        //     //     .typeError('Discount must be a number')
        //     //     .min(0, 'Discount cannot be negative')
        //     //     .max(100, 'Discount cannot be more than 100')
        //     //     .nullable(),
        //     // status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),
        //     // features: Yup.array().of(
        //     //     Yup.object()
        //     //         .shape({
        //     //             name: Yup.string().required('Feature name is required'),
        //     //             value: Yup.string(),
        //     //         })
        //     //         .optional()
        //     // ),
    });

    const formHandler = (values) => {
        console.log('Before apiHandler Form Values: ', values);
        // return null;
        const formData = formDataConverterNew(values);
        console.log('After formData Convert formData: ', values);
        if (apiHandler) {
            return apiHandler(formData);
            // return apiHandler(values);
        }
        return null;
    };

    return (
        <div>
            <CrudFormLayout
                initialValues={initialValues}
                buttonCenter
                apiHandler={formHandler}
                validationSchema={validationSchema}
            >
                <PackageForm />
            </CrudFormLayout>
        </div>
    );
};

export default PackageFormContainer;
